import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPatchBuildingsInspection_alerts_inspectionIdDismiss = z.any()
export type TagsPatchBuildingsInspection_alerts_inspectionIdDismiss = z.infer<typeof tagsPatchBuildingsInspection_alerts_inspectionIdDismiss>

export const paramsPatchBuildingsInspection_alerts_inspectionIdDismiss = z.object({ "inspectionId": z.string().uuid() })
export type ParamsPatchBuildingsInspection_alerts_inspectionIdDismiss = z.infer<typeof paramsPatchBuildingsInspection_alerts_inspectionIdDismiss>

export const bodyPatchBuildingsInspection_alerts_inspectionIdDismiss = z.object({ "dueDate": z.string().min(8).max(64) })
export type BodyPatchBuildingsInspection_alerts_inspectionIdDismiss = z.infer<typeof bodyPatchBuildingsInspection_alerts_inspectionIdDismiss>

export const responsePatchBuildingsInspection_alerts_inspectionIdDismiss = z.any()
export type ResponsePatchBuildingsInspection_alerts_inspectionIdDismiss = z.infer<typeof responsePatchBuildingsInspection_alerts_inspectionIdDismiss>

interface IPatchBuildingsInspection_alerts_inspectionIdDismiss extends BaseMethodType {
  tags: TagsPatchBuildingsInspection_alerts_inspectionIdDismiss,
  params: ParamsPatchBuildingsInspection_alerts_inspectionIdDismiss,
  body: BodyPatchBuildingsInspection_alerts_inspectionIdDismiss,
  response: ResponsePatchBuildingsInspection_alerts_inspectionIdDismiss
}
export const URL = '/buildings/inspection-alerts/:inspectionId/dismiss'
export const validation = {
  patch: {
    tags: tagsPatchBuildingsInspection_alerts_inspectionIdDismiss,
    params: paramsPatchBuildingsInspection_alerts_inspectionIdDismiss,
    body: bodyPatchBuildingsInspection_alerts_inspectionIdDismiss,
    response: responsePatchBuildingsInspection_alerts_inspectionIdDismiss
  }
}
export interface BuildingsInspection_alerts_inspectionIdDismiss extends BaseRouteType {
  patch: IPatchBuildingsInspection_alerts_inspectionIdDismiss
}